const v2 = {
  page_loader_errors: {
    failed_to_load_dependencies: 'An error occurred while loading the page content',
    unspecified: 'Oops! Something went wrong.',
    unauthorized: 'Unauthorized.',
    unauthenticated: 'Authentication required.',
    no_domain_policy_access: 'Access denied'
  },
  field_errors: {
    invalid_value: 'Invalid value',
    required_value: 'Required value',
    invalid_email: 'Invalid email address',
    email_domain_not_allowed: 'The email address must belong to a domain you manage.',
    outbound_email_ids_required: 'Admin quarantine notification address must be provided.'
  }
}

export default v2
